<template>
  <div class="promotion-popup" :class="{ loading }">
    <popup :buttons="buttons" :close-action="closeModal">
      <template v-slot:title>
        <img class="logo-image" :src="require('@/assets/promotions/discount/discount-riseup.svg')">
        <div class="popup-title">מגיע לך חודשיים ללא חיוב מתנה!</div>
      </template>
      <template v-slot:content>
        <div class="description">
          <span>לקוחות דיסקונט שנרשמים לשירות עם אחד מכרטיסי האשראי של דיסקונט מקבלים
            <span class="bold">בנוסף לחודש הנסיון </span>גם חודשיים של המנוי במתנה. </span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../../Segment';

export default {
  name: 'PromotionPopup',
  props: {
    closePopup: {
      type: Function,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserGot('DiscountPromotionPopupShown');
  },
  computed: {
    buttons() {
      return [
        {
          title: 'הבנתי, תודה',
          action: this.closeModal,
          loading: this.loading,
          size: 'slim',
        },
      ];
    },
  },
  methods: {
    closeModal() {
      this.closePopup();
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>

  .promotion-popup {
    &.loading{
      opacity: 0.5;
      pointer-events: none;
    }

    .popup-title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 19px;
      line-height: 24px;
      margin-bottom: 18px;
    }

    .logo-image {
      width: 100%;
      text-align: center;
      height: 110px;
      margin-bottom: 30px;
    }

    .description {
      font-family: SimplerPro;
      margin-bottom: 80px;
      line-height: 1.38;
      text-align: center;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>
